// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","948":"2cca2479","976":"c16184b3"}[chunkId] + "-" + {"218":"8d2789f24e920a45358e","691":"5ecf27077a13faae34d4","948":"bd74185bc86d42169fd9","976":"bec30648f03e120d14f1"}[chunkId] + ".js";
};